import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const cityStateGst = createAsyncThunk('cityStateGst', async (data) => {

    try {
        const res = await axios({

            method: 'Post',
            url: process.env.REACT_APP_API_URL + `search_and_create_city`,
            data: {
                'city': data?.city,
                'state': data?.state
            },
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const cityStateGstSlice = createSlice({
    name: 'cityStateGst',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(cityStateGst.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                state.data = [];
                localStorage.clear();
                action?.meta?.arg?.navigate('../login')
            } else {
                state.data = [];
            }
        });
        builder.addCase(cityStateGst.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default cityStateGstSlice.reducer; 